import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent, trackPageView, trackSessionEnd, trackSessionStart } from 'services/analytics';

function AnalyticsListener() {
  const location = useLocation();
  const sessionStartedAtRef = useRef(Date.now());

  useEffect(() => {
    const path = location.pathname + (location.search || '');
    const pageStartedAt = Date.now();

    trackSessionStart();
    trackPageView(path);

    return () => {
      trackEvent('PAGE_EXIT', {
        page_path: location.pathname,
        duration_seconds: Math.max(0, Math.round((Date.now() - pageStartedAt) / 1000)),
      });
    };
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handlePageHide = () => {
      trackSessionEnd({
        duration_seconds: Math.max(0, Math.round((Date.now() - sessionStartedAtRef.current) / 1000)),
      });
    };

    window.addEventListener('pagehide', handlePageHide);
    return () => window.removeEventListener('pagehide', handlePageHide);
  }, []);

  return null;
}

export default AnalyticsListener;
